import { render } from "./SectionTesti.vue?vue&type=template&id=ee46cd34"
import script from "./SectionTesti.vue?vue&type=script&lang=js"
export * from "./SectionTesti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__